import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("g", { filter: "url(#filter0_d_11512_209203)" }, [
  /*#__PURE__*/_createVNode("rect", {
    x: "8",
    y: "8.42041",
    width: "30",
    height: "30",
    rx: "4.28571",
    fill: "#B82025"
  }),
  /*#__PURE__*/_createVNode("rect", {
    x: "6.5",
    y: "6.92041",
    width: "33",
    height: "33",
    rx: "5.78571",
    stroke: "white",
    "stroke-width": "3",
    fill: "#B82025"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("mask", {
  id: "mask0_11512_209203",
  style: {"mask-type":"alpha"},
  maskUnits: "userSpaceOnUse",
  x: "8",
  y: "8",
  width: "30",
  height: "31"
}, [
  /*#__PURE__*/_createVNode("rect", {
    x: "8",
    y: "8.42041",
    width: "30",
    height: "30",
    rx: "4.28571",
    fill: "#FF0000"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("g", { mask: "url(#mask0_11512_209203)" }, [
  /*#__PURE__*/_createVNode("circle", {
    cx: "37.4643",
    cy: "13.2419",
    r: "14.4643",
    fill: "#C64D51"
  }),
  /*#__PURE__*/_createVNode("circle", {
    cx: "4.24993",
    cy: "36.8132",
    r: "21.9643",
    fill: "#E13E49"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("g", { filter: "url(#filter1_d_11512_209203)" }, [
  /*#__PURE__*/_createVNode("path", {
    d: "M33 19.5743V31.882C33 32.29 32.8379 32.6813 32.5494 32.9698C32.2609 33.2583 31.8696 33.4204 31.4616 33.4204H14.5385C14.1304 33.4204 13.7391 33.2583 13.4506 32.9698C13.1621 32.6813 13 32.29 13 31.882V19.5743L15.3077 15.1281C15.8053 14.1259 16.866 13.4492 17.9846 13.4204H28.0154C29.1603 13.421 30.2597 14.1028 30.7693 15.1281L33 19.5743Z",
    fill: "white"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M15.3077 15.1281L13 19.5743H33L30.7693 15.1281C30.2597 14.1028 29.1603 13.421 28.0154 13.4204H17.9846C16.866 13.4492 15.8053 14.1259 15.3077 15.1281Z",
    fill: "#EABCBE"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M22.1072 19.5743V13.4204H23.8929V19.5743H22.1072Z",
    fill: "white"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M24.0715 23.0634C24.0715 22.4716 23.5918 21.9919 23 21.9919C22.4083 21.9919 21.9286 22.4716 21.9286 23.0634V25.5634H19.4286C18.8369 25.5634 18.3572 26.0431 18.3572 26.6348C18.3572 27.2265 18.8369 27.7062 19.4286 27.7062H21.9286V30.2062C21.9286 30.7979 22.4083 31.2777 23 31.2777C23.5918 31.2777 24.0715 30.7979 24.0715 30.2062V27.7062H26.5715C27.1632 27.7062 27.6429 27.2265 27.6429 26.6348C27.6429 26.0431 27.1632 25.5634 26.5715 25.5634H24.0715V23.0634Z",
    fill: "#EABCBE"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("defs", null, [
  /*#__PURE__*/_createVNode("filter", {
    id: "filter0_d_11512_209203",
    x: "1",
    y: "1.42041",
    width: "44",
    height: "44",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, [
    /*#__PURE__*/_createVNode("feFlood", {
      "flood-opacity": "0",
      result: "BackgroundImageFix"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      in: "SourceAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      result: "hardAlpha"
    }),
    /*#__PURE__*/_createVNode("feOffset"),
    /*#__PURE__*/_createVNode("feGaussianBlur", { stdDeviation: "2" }),
    /*#__PURE__*/_createVNode("feComposite", {
      in2: "hardAlpha",
      operator: "out"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0.721569 0 0 0 0 0.12549 0 0 0 0 0.145098 0 0 0 0.5 0"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in2: "BackgroundImageFix",
      result: "effect1_dropShadow_11512_209203"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in: "SourceGraphic",
      in2: "effect1_dropShadow_11512_209203",
      result: "shape"
    })
  ]),
  /*#__PURE__*/_createVNode("filter", {
    id: "filter1_d_11512_209203",
    x: "7.28571",
    y: "13.4204",
    width: "31.4286",
    height: "31.4286",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, [
    /*#__PURE__*/_createVNode("feFlood", {
      "flood-opacity": "0",
      result: "BackgroundImageFix"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      in: "SourceAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      result: "hardAlpha"
    }),
    /*#__PURE__*/_createVNode("feOffset", { dy: "5.71429" }),
    /*#__PURE__*/_createVNode("feGaussianBlur", { stdDeviation: "2.85714" }),
    /*#__PURE__*/_createVNode("feComposite", {
      in2: "hardAlpha",
      operator: "out"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in2: "BackgroundImageFix",
      result: "effect1_dropShadow_11512_209203"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in: "SourceGraphic",
      in2: "effect1_dropShadow_11512_209203",
      result: "shape"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6
  ]))
}